import { MessageCircle } from "lucide-react";

const WHATSAPP_URL =
  "https://wa.me/919239645335?text=" +
  encodeURIComponent("Hi Resort The Forest! I'd like to ask about a stay.");

export const WhatsAppButton = () => {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-chat-btn"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white pl-4 pr-5 py-3 rounded-full shadow-[0_8px_30px_rgb(0,0,0,0.18)] hover:bg-[#1fb857] hover:scale-105 transition-all duration-300"
    >
      <MessageCircle className="w-5 h-5" fill="white" strokeWidth={0} />
      <span className="text-xs font-bold uppercase tracking-[0.15em] hidden sm:inline">Chat with us</span>
    </a>
  );
};
